import { setAlert } from 'context/reducer/app'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

function getOnlineStatus() {
  return typeof navigator !== 'undefined' &&
    typeof navigator.onLine === 'boolean'
    ? navigator.onLine
    : true
}
export function useOnlineStatus() {
  const [onlineStatus, setOnlineStatus] = useState(getOnlineStatus())
  const dispatch = useDispatch()

  const goOnline = () => {
    dispatch(setAlert({
      open: true,
      status: 2,
      text: 'No podemos conectarnos a una red; verifica tu conexión a internet.',
    }))
    setOnlineStatus(false)
  }
  const goOffline = () => setOnlineStatus(false)

  useEffect(() => {
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)

    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
    // eslint-disable-next-line
  }, [])

  return onlineStatus
}

export function capital_letter(str: string) {
  const strCapitalize = str.split(' ')
  return strCapitalize
    .map(
      (strWord) =>
        strWord.charAt(0).toUpperCase() + strWord.toLowerCase().substring(1)
    )
    .join(' ')
}
const identifitacionNotAllowed = [
  '0000000000',
  '1111111111',
  '2222222222',
  '3333333333',
  '4444444444',
  '5555555555',
  '6666666666',
  '7777777777',
  '8888888888',
  '9999999999',
]
export function validateEmailPhone(value: string, type: string) {
  if (type === 'email') {
    return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
  }
  if (+value.substring(0, 1) === 0 && value.length === 10) {
    return true
  }
  return false
}
export function validateIdentification(value: string) {
  if (value.length !== 10) {
    return false
  }
  if (identifitacionNotAllowed.includes(value)) {
    return false
  }
  let digit: string
  /* convert to array of int for simplicity */
  // tslint:disable-next-line: prefer-array-literal
  const digits: number[] = new Array(value.length - 1)
  for (let i = 0; i < value.length - 1; i += 1) {
    digits[i] = +value.charAt(i)
  }

  /* double every other starting from right - jumping from 2 in 2 */
  for (let i = digits.length - 1; i >= 0; i -= 2) {
    digits[i] += digits[i]
    /* taking the sum of digits grater than 10 - simple trick by substract 9 */
    if (digits[i] >= 10) {
      digits[i] -= 9
    }
  }
  let sum = 0
  digits.forEach((item: number) => {
    sum += item
  })
  /* multiply by 9 step */
  sum *= 9
  /* convert to string to be easier to take the last digit */
  digit = sum.toString()
  const lastDigit = digit.substring(digit.length - 1)
  return value.substring(value.length - 1) === lastDigit
}
